import { Component, Input, OnChanges, OnInit } from '@angular/core';

/** Shared profile avatar: image or 1st character with brand fallback colors. */
@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent implements OnInit, OnChanges {
  @Input() src: string | null | undefined;
  @Input() name: string | null | undefined;
  @Input() fname: string | null | undefined;
  @Input() lname: string | null | undefined;
  /** CSS size, e.g. 40, '40px', '2.5rem' */
  @Input() size: number | string = 40;
  @Input() alt = 'avatar';
  @Input() round = true;

  displaySrc = '';
  initial = '?';
  sizeCss = '40px';

  ngOnInit(): void {
    this.refresh();
  }

  ngOnChanges(): void {
    this.refresh();
  }

  private refresh(): void {
    this.displaySrc = String(this.src || '').trim();
    this.initial = UserAvatarComponent.firstChar(
      this.name,
      this.fname,
      this.lname
    );
    this.sizeCss =
      typeof this.size === 'number' ? `${this.size}px` : String(this.size || '40px');
  }

  static firstChar(
    name?: string | null,
    fname?: string | null,
    lname?: string | null
  ): string {
    const fromName = String(name || '').trim();
    if (fromName) {
      return fromName.charAt(0).toUpperCase();
    }
    const fromF = String(fname || '').trim();
    if (fromF) {
      return fromF.charAt(0).toUpperCase();
    }
    const fromL = String(lname || '').trim();
    if (fromL) {
      return fromL.charAt(0).toUpperCase();
    }
    return '?';
  }

  onImgError(): void {
    this.displaySrc = '';
  }
}
